import React from 'react'
import { Route } from 'react-router'
import Plans from 'client/routes/Plans/Plans';

const PlansRoutes = (
    <Route path="/plans" component={ Plans } title="Planer">
    </Route>
)

export default PlansRoutes